import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconDefinition, faPhone } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { SamwebBrick } from 'src/app/components/bricks/samweb-brick.decorator';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { BrickCategory } from 'src/app/samwebDescription/samweb/brickCategoryType';
import { BrickLocationType } from 'src/app/samwebDescription/samweb/brickLocationType';
import { CallControlSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/call-control-settings/call-control-settings.state';
import { CallControlBrickBaseComponent } from './call-control-brick.base.component';
import { CallControlBrickSmallComponent } from './call-control-brick.small.component';
import { CallControlSettingsComponent } from './call-control-settings/call-control-settings.component';

@Component({
   selector: 'samweb-call-control-brick-default',
   templateUrl: './call-control-brick.default.component.html',
   styleUrls: ['./call-control-brick.default.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
@SamwebBrick({
   brickDefinitionId: 'callControlBrick',
   brickTitleTranslationKey: 'brick.brick_definitions.call_control.title',
   brickDescriptionTranslationKey: 'brick.brick_definitions.call_control.description',
   brickIcon: faPhone,
   minColWidth: 11,
   minRowHeight: 15,
   collapsedRowHeight: 10,
   brickCategory: BrickCategory.CALLING,
   allowedBrickLocation: BrickLocationType.BOTH,
   settingsComponent: CallControlSettingsComponent,
   settingStateHandler: CallControlSettingsState,
   smallBrickComponentAlternative: CallControlBrickSmallComponent,
})
export class CallControlBrickDefaultComponent extends CallControlBrickBaseComponent {
   public cancelIcon: IconDefinition = WellKnownIconsEnum.CANCEL.icon;
   constructor(store: Store) {
      super(store);
   }
}
